import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PaymentCart } from '@cargos/sprintpay-models';
import { Subject, takeUntil } from 'rxjs';
import { CartBillService, ConfigService } from 'src/app/shared/services';

@Component({
    selector: 'app-awb-item',
    templateUrl: './awb-item.component.html',
    styleUrls: ['./awb-item.component.scss'],
    imports: [MatIconModule],
    standalone: true,
})
export class AwbItemComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public isDuplicated = false;
    public labelHAWB: string = '';
    @Input() paymentCart: PaymentCart;

    constructor(
        private cartBillService: CartBillService,
        private configService: ConfigService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeItemsDuplicates();
        this.getLabelsConfig();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeItemsDuplicates(): void {
        this.cartBillService
            .isThereDuplicatesByPayment(this.paymentCart)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((isDuplicated) => {
                this.isDuplicated = isDuplicated;
            });
    }

    getLabelsConfig(): void {
        this.labelHAWB = this.configService.getLabelHAWB();
    }
}
